import { createSlice } from '@reduxjs/toolkit';
import { addSpecialistToFavourite, fetchFavouriteSpecialists, removeSpecialistFromFavourite } from './thunk';
import { ISpecialist } from '../specialists/types';
import { fetchSpecialistsList } from '../specialists/thunk';
import { fetchLastContract, fetchSpecialistByID } from '../loadedSpecialists/thunk';
import { updateReview } from '../specialistReviews/thunk';

type FavoriteSpecialistsStore = {
  data: ISpecialist[] | null;
  loading: 'idle' | 'pending' | 'succeeded' | 'failed';
};

export const initialState: FavoriteSpecialistsStore = {
  data: null,
  loading: 'idle',
};

const favouriteSpecialists = createSlice({
  name: 'favouriteSpecialists',
  initialState,
  reducers: {
    resetFavouriteSpecialists: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpecialistByID.fulfilled, (state, action) => {
        state.data = state.data
          ? state.data.map((item) => {
              if (item.id === action.payload.id) {
                return {
                  ...item,
                  ...action.payload,
                };
              }
              return item;
            })
          : null;
        state.loading = 'succeeded';
      })
      .addCase(fetchLastContract.fulfilled, (state, action) => {
        if (!state.data || !action.payload) return;
        state.data?.map((item) => {
          if (item.id === action.payload.specialist_id) {
            return {
              ...item,
              client: {
                specialist_client_contract_status: action.payload.status,
                specialist_client_contract_id: action.payload.id,
              },
            };
          }
          return item;
        });
      })
      .addCase(fetchFavouriteSpecialists.pending, (state) => {
        state.loading = 'pending';
      })
      .addCase(fetchFavouriteSpecialists.fulfilled, (state, action) => {
        const actionPayloadData = action?.payload ?? null;
        state.data = actionPayloadData.sort(
          (specialistA: ISpecialist, specialistB: ISpecialist) =>
            (specialistB?.percent_match ?? 0) - (specialistA?.percent_match ?? 0)
        );

        state.loading = 'succeeded';
      })
      .addCase(fetchSpecialistsList.rejected, (state) => {
        state.loading = 'failed';
      })
      .addCase(addSpecialistToFavourite.pending, (state, action) => {
        if (action.meta.arg && !state.data?.find((specialist) => specialist.id === action.meta.arg.id)) {
          state.data = state.data ? [...state.data, action.meta.arg as ISpecialist] : [action.meta.arg as ISpecialist];
        }
      })
      .addCase(removeSpecialistFromFavourite.pending, (state, action) => {
        state.data = state.data?.filter((specialist) => specialist.id !== action.meta.arg.id) ?? null;
      })
      .addCase(updateReview.fulfilled, (state, action) => {
        if (!state.data || !action.payload) return;

        state.data?.map((item) => {
          if (item.id === action.payload.specialist_id) {
            return {
              ...item,
              reviews_count: action.payload.specialist.reviews_count,
              reviews_average_rating: action.payload.specialist.reviews_average_rating,
              reviews_count_by_stars: action.payload.specialist.reviews_count_by_stars,
            };
          }
          return item;
        });
      });
  },
});

export const { resetFavouriteSpecialists } = favouriteSpecialists.actions;

export default favouriteSpecialists.reducer;
